import { Chip, CircularProgress, Box } from "@mui/material";

const TRANSITORY_STATES = [
  "STARTING",
  "STOPPING",
  "RECOVERING",
  "UPDATING",
  "CREATING",
  "DELETING",
];

const ERROR_STATES = [
  "ERRORED",
  "CREATE_FAILED",
  "UPDATE_FAILED",
  "DELETED",
];

const getColor = (state) => {
  if (state === "RUNNING") return "success";
  if (state === "IDLE") return "default";
  if (TRANSITORY_STATES.includes(state)) return "warning";
  if (ERROR_STATES.includes(state)) return "error";
  return "default";
};

const pulseSx = {
  "@keyframes streamPulse": {
    "0%": { boxShadow: "0 0 0 0 rgba(46, 125, 50, 0.6)" },
    "70%": { boxShadow: "0 0 0 8px rgba(46, 125, 50, 0)" },
    "100%": { boxShadow: "0 0 0 0 rgba(46, 125, 50, 0)" },
  },
  animation: "streamPulse 2s infinite",
};

const StateChip = ({ state }) => {
  const label = state || "DESCONOCIDO";
  const color = getColor(state);
  const isTransitory = TRANSITORY_STATES.includes(state);
  const isRunning = state === "RUNNING";

  return (
    <Chip
      label={
        <Box sx={{ display: "inline-flex", alignItems: "center" }}>
          {label}
          {isTransitory && (
            <CircularProgress size={12} sx={{ ml: 1 }} color="inherit" />
          )}
        </Box>
      }
      color={color}
      variant={color === "default" ? "outlined" : "filled"}
      sx={isRunning ? pulseSx : undefined}
    />
  );
};

export default StateChip;
